module.exports = __webpack_public_path__ + "static/media/Users.3a323ba4.svg";